export default __webpack_public_path__ + "static/media/nepal_solar.5ca8b1d4.png";